import { useEffect } from "react";
import styles from "./battery.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import { useRef } from "react";
import DOMPurify from "dompurify";
gsap.registerPlugin(ScrollTrigger);
const Battery = ({textData}) => {
  return (
    <div className={styles.ctn}>
      <div className={`${styles.textBox}`}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text32"]),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text33"]),
          }}
        ></h5>
      </div>
      <div className={styles.paramsBox}>
        <div>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text35"]),
            }}
          ></h5>
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text36"]),
            }}
          ></h3>
        </div>
        <div>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text37"]),
            }}
          ></h5>
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text38"]),
            }}
          ></h3>
        </div>
        <div>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text39"]),
            }}
          ></h5>
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text40"]),
            }}
          ></h3>
        </div>
      </div>

      <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text34"]),
          }}
        ></h6>

      <div className={styles.imgBox}>
        <img
          src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/wbl3/wbl3-detail-media-7-1.jpg"
          alt="WEEBILL 3"
        />

      </div>
    </div>
  );
};

export default Battery;
